export default 
{
  type: "form-dropdown",
  style: "",
  data: {
    label: "New Dropdown Field",
    placeholder: "Please Select",
    options: [
      {
        label: "Option 1",
      },
      {
        label: "Option 2",
      },
      {
        label: "Option 3",
      }
    ],
  },
  children: [],
};
